<div class="form-container">
        <div *ngIf="isLoading" class="spinner-container">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'1000ms'"
        [hideTransitionOptions]="'1000ms'"/>

        <form [formGroup]="newPasswordForgotForm" (ngSubmit)="changePassword()">

          <div class="grid" *ngIf="!sendNewPAsswordOk">

            <div class="col-12 md:col-12">
            <span class="titleSection font-bold text-xl">Restablecer contraseña</span>
            </div>

            <div class="col-12 md:col-12 pb-0">
                <label class="labelTitle">Nueva contraseña *</label>
            </div>

            <div class="col-12 md:col-10">
                <span class="p-input-icon-right flex flex-column">
                    <i style="color: #667085" [ngClass]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"
                        (click)="togglePasswordVisibility()"></i>
                    <input pInputText id="newPassword" type="{{ showPassword ? 'text' : 'password' }}"
                        maxlength="32" placeholder="Ingrese la nueva contraseña" autocomplete="off"
                        formControlName="newPassword"
                        [ngClass]="{'input-error': newPasswordForgotForm.get('newPassword')?.invalid && newPasswordForgotForm.get('newPassword')?.touched}" />
                </span>
                <div class="p-error mt-1" *ngIf="newPasswordForgotForm.get('newPassword')?.hasError('invalidPassword') && newPasswordForgotForm.get('newPassword')?.touched">
                    La contraseña debe cumplir con todos los requisitos.
                </div>
            </div>

            <div class="col-12 md:col-10 mt-2 pb-0">
            <label for="repeatPassword" id="laber-span" class="labelTitle mb-1">Repetir nueva contraseña *</label>
            </div>
            <div class="col-12 md:col-10">
              <span class="p-input-icon-right flex flex-column">
                  <i style="color: #667085" [ngClass]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"
                      (click)="togglePasswordVisibility()"></i>
                  <input pInputText id="repeatPassword" type="{{ showPassword ? 'text' : 'password' }}" maxlength="32"
                      placeholder="Repita la nueva contraseña" autocomplete="off" formControlName="repeatedPassword"
                      [ngClass]="{'input-error': newPasswordForgotForm.get('repeatedPassword')?.invalid && newPasswordForgotForm.get('repeatedPassword')?.touched}" />
              </span>
              <div class="p-error mt-1" *ngIf="newPasswordForgotForm.hasError('mismatch') && newPasswordForgotForm.get('repeatedPassword')?.touched">
                  Las contraseñas no coinciden.
              </div>
          </div>

                <div class="col-12 flex flex-column">
                    <span class="mt-2 passValidators" id="uppercase"><i class="pi pi-check-circle"></i> Al menos un
                        carácter en
                        mayúscula</span>
                    <span class="mt-2 passValidators" id="lowercase"><i class="pi pi-check-circle"></i> Al menos un
                        carácter en
                        minúscula</span>
                    <span class="mt-2 passValidators" id="minlength"><i class="pi pi-check-circle"></i> Mínimo 8
                        caracteres</span>
                    <span class="mt-2 passValidators" id="number"><i class="pi pi-check-circle"></i> Mínimo un
                        número</span>
                    <span class="mt-2 passValidators" id="specialChar"><i class="pi pi-check-circle"></i> Mínimo un
                        carácter
                        especial</span>
                </div>

            <div class="col-12 md:col-10">
            <p-button class="nextButton" label="Cambiar contraseña" type="submit"
                     [disabled]="newPasswordForgotForm.invalid || newPasswordForgotForm.get('newPassword')?.hasError('invalidPassword')">
                    </p-button>
                    <span class="backLink"><a [routerLink]="['/auth/login']">Volver</a></span>
                </div>

            </div>

          <div *ngIf="sendNewPAsswordOk" class="grid mt-2">

          <div class="col-12 md:col-8">
            <span class="font-bold text-xl mt-2 mb-2">Restablecer contraseña</span>
          </div>

          <div class="col-12 md:col-10 ">
            <div class="information">
            <img src="../../../../../../../assets/img/register/check-account.png" alt="">
            <span>Su contraseña ha sido actualizada con éxito.</span>
            </div>
          </div>

          <div class="col-12 md:col-10">
            <p-button class="mt-2" label="Iniciar sesión" type="button" [routerLink]="['/auth/login']"></p-button>
          </div>

          </div>

        </form>
</div>
